import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STORAGE_KEY = "adminDisplayPreference";
const OPTIONS = ["auto", "desktop", "compact"];

export function useAdminDisplayPreference() {
  const [preference, setPreferenceState] = useState(() => {
    if (typeof window === "undefined") return "auto";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return OPTIONS.includes(saved) ? saved : "auto";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, preference);
    }
  }, [preference]);

  const setPreference = (value) => {
    setPreferenceState(OPTIONS.includes(value) ? value : "auto");
  };

  return [preference, setPreference];
}

export function adminShellClassName(preference) {
  if (preference === "desktop") return "max-w-7xl";
  if (preference === "compact") return "max-w-md";
  return "max-w-md lg:max-w-7xl";
}

export default function AdminDisplayPreference({ value, onChange }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-[128px] rounded-xl bg-white text-xs" aria-label="Admin display preference">
        <SelectValue placeholder="Display" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="auto">Auto</SelectItem>
        <SelectItem value="desktop">Desktop</SelectItem>
        <SelectItem value="compact">Compact</SelectItem>
      </SelectContent>
    </Select>
  );
}
